import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PLATFORM_HOME } from '../utils/hubSession';
import { usePlatformName } from '../contexts/PlatformBrandingContext';

/** What each reason means for the person, and what to do (`platform`: its name). */
const messagesFor = (platform) => ({
  'signed-out': {
    title: 'You signed out',
    body: `You have signed out of the BMS. Open it again from ${platform} whenever you need it.`
  },
  inactive: {
    title: 'Signed out after inactivity',
    body: `You were signed out because the BMS was not used for a while. Open it again from ${platform} to carry on.`
  },
  expired: {
    title: 'Your session has ended',
    body: `The BMS could not confirm your session any more. Open it again from ${platform} to sign in afresh.`
  },
  'no-session': {
    title: 'You are not signed in',
    body: `The BMS is opened from ${platform}. Go back and open it from your business there.`
  },
  closed: {
    title: 'Your access has been turned off',
    body: `Your access to the BMS in this business has been turned off, here or in ${platform}. Ask the business's owner or an admin to turn it back on.`
  }
});

/**
 * Where a session that came from One Manager ends up when it ends: it says why and offers a
 * button back to One Manager. Nothing sends the person there by itself.
 */
export default function SessionEndedPage() {
  const platformName = usePlatformName();
  const [params] = useSearchParams();
  const messages = messagesFor(platformName);
  const message = messages[params.get('reason')] || messages.expired;
  const call = params.get('call');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">{message.title}</h1>
        <p className="text-gray-600 mb-6">{message.body}</p>
        {PLATFORM_HOME ? (
          <a
            href={PLATFORM_HOME}
            className="block w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to {platformName}
          </a>
        ) : (
          <p className="text-sm text-gray-500">Go back to {platformName} and open the BMS from there.</p>
        )}
        {call && (
          <p className="mt-6 text-xs text-gray-400 break-all">
            Details for support: the request {call} was refused.
          </p>
        )}
      </div>
    </div>
  );
}
